import { css } from '@emotion/css';

import { colors } from '@ajaibid/components';

export const styAccountWrapper = css`
  position: absolute;
  top: 0px;
  margin: 16px;
  background: white;
  width: 318px;
  height: 74px;
  border: 1px solid;
  padding: 16px;
  display: flex;
  flex-flow: row wrap;
  border-radius: 12px;
  border: 1px solid ${colors.NEUTRAL_2};
  justify-content: space-between;
  cursor: pointer;
`;

export const styAccountInfo = css`
  display: flex;
`;

export const styImgAccount = css`
  width: 42px;
  height: 42px;
  border-radius: 40px;
`;

export const styAccountName = css`
  display: flex;
  justify-content: center;
  flex-flow: column;
  margin-left: 12px;
`;

export const styAccountIcon = css`
  display: flex;
  justify-content: center;
  flex-flow: column;
`;

export const styAccountUser = css`
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
`;

export const styAccountPrimeBadge = css`
  background: linear-gradient(0deg, ${colors.SLATE_GRAY_7}, ${colors.SLATE_GRAY_7}),
    linear-gradient(270deg, rgba(255, 255, 255, 0.2) -1.79%, rgba(0, 0, 0, 0) 100%);
  box-shadow: 0px 2px 8px -2px rgba(96, 122, 141, 0.15);
  border-radius: 12px;
  padding: 2px 8px 2px 8px;
  color: white;
  width: 50px;
`;
